module.exports = __webpack_public_path__ + "img/4040_1.78c73ef7.png";